const touchAction = {
    name: "touch-action",
    path: "touch-action",
    title: "touch-action",
    description: "Utilities for controlling the CSS touch-action property.",
    value: {
        "touch-action": {
            "touch-auto": "auto",
            "touch-none": "none",
            "touch-pan-x": "pan-x",
            "touch-pan-left": "pan-left",
            "touch-pan-right": "pan-right",
            "touch-pan-y": "pan-y",
            "touch-pan-up": "pan-up",
            "touch-pan-down": "pan-down",
            "touch-pinch-zoom": "pinch-zoom",
            "touch-manipulation": "manipulation"
        }
    },
    exampleData: [
        {
            title: "touch-pan-y, touch-pinch-zoom",
            description: "to control how an element can be scrolled (panned) and zoomed (pinched) on touchscreens:",
            moreDescription: "Try panning these images on a touchscreen",
            "parentClass": "grid md:grid-columns-2 gap-x-6 gap-y-20 !bg-none !border-0 !mt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "text": "touch-auto",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": " h-auto w-[150%] max-w-none",
                        "containerClass":"h-48 w-full overflow-auto rounded-lg touch-auto"
                    },
                    {
                        "text": "touch-none",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": " h-auto w-[150%] max-w-none",
                        "containerClass":"h-48 w-full overflow-auto rounded-lg touch-none"
                    },
                    {
                        "text": "touch-pan-x",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": " h-auto w-[150%] max-w-none",
                        "containerClass":"h-48 w-full  overflow-auto rounded-lg touch-pan-x"
                    },
                    {
                        "text": "touch-pan-y",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": " h-auto w-[150%] max-w-none",
                        "containerClass":"h-48 w-full  overflow-auto rounded-lg touch-pan-y"
                    }
                ],
                "className": "relative snap-center shrink-0",
                "code": `<div class="h-48 w-full touch-auto overflow-auto ...">
  <img class="h-auto w-[150%] max-w-none" src="..." />
</div>
<div class="h-48 w-full touch-none overflow-auto ...">
  <img class="h-auto w-[150%] max-w-none" src="..." />
</div>
<div class="h-48 w-full touch-pan-x overflow-auto ...">
  <img class="h-auto w-[150%] max-w-none" src="..." />
</div>
<div class="h-48 w-full touch-pan-y overflow-auto ...">
  <img class="h-auto w-[150%] max-w-none" src="..." />
</div>`
            }
        }
    ],
};

export default touchAction;